<template>
    <div>
        <button
                class="btn btn-block"
                :class="['btn-' + type, small?'':'btn-lg']"
                @click="$emit('click', $event)"
                :disabled="disabled"
                v-text="text"/>
    </div>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                default: 'primary'
            },
            text: {
                type: String,
                required: true
            },
            small: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/colors";

    .btn {
        font-family: "Open Sans";
        text-transform: none;
        border-radius: 3px;
        display: block;
        font-size: 18px;
        font-weight: bold;
        padding: 0;
        transition: background 0.3s;
        height: 40px;
        line-height: 30px;
    }

    .btn-lg {
        height: 60px;
        line-height: 60px;
    }

    .btn-primary {
        background-color: $orange;
        border-color: $orange;
        color: #fff;
        height: 60px;
        line-height: 60px;

        &:hover, &:active {
            background: lighten($orange, 5%) !important;
            border-color: lighten($orange, 5%) !important;
        }

        &:disabled{
            background: lighten($orange, 15%);
            border-color: lighten($orange, 15%);
        }
    }

    .btn-dev {
        background: #fff;
    }

    .btn-secondary {
        background-color: #fff;
        border-color: $orange;
        color: $orange;
        font-weight: bold;

        &:hover, &:active {
            background-color: #fff;
            border-color: lighten($orange, 5%) !important;
            color: $orange;
        }
    }

    .btn-facebook {
        background: $facebook;
        border-color: $facebook;
        color: #fff;

        &:hover, &:active {
            background: lighten($facebook, 5%) !important;
            border-color: lighten($facebook, 5%) !important;
            color: #fff;
        }
    }
</style>
